import { useDispatch, useSelector } from "react-redux/es/exports";
import { Box, Stack, Typography, Divider, Avatar } from '@mui/material';
import { useEffect, useState } from "react";
import { setIpInformation } from "../features/ipInformationSlice";
import { setError } from "../features/errorsSlice";
import Loading from "./Loading.tsx";
import AccountMenu from './Menu.tsx';
import IpLookup from "./IpLookup";
import UpperText from "./UpperText";
import LowerText from "./LowerText";
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

const Home = () => {
    const ipInformation = useSelector((state) => state.information.value);
    const errors = useSelector((state) => state.errors.value);
    let [loading, setLoading] = useState(true);
    const [ipStatusText, setIpStatusText] = useState("Your Public Ip Address: ");
    const informationDispatch = useDispatch();
    const errorsDispatch = useDispatch();
    const url = 'https://api.ipgeolocation.io/ipgeo?apiKey=d7ed028f02d947b9a6e9ebbbfb6fdb13';

    /* get public ip info while loading page */
    useEffect(() => {

        fetch(url).then((res) => {


            if (res.status === 401)  {
                errorsDispatch(setError("error401: Account has been disabled"));
                setLoading(false);
                setIpStatusText("");
                informationDispatch(setIpInformation({}));
            }
            if (res.status === 403)  {
                errorsDispatch(setError("error403: IP to geolocation look-up for a domain name is done using a free subscription API key"));
                setLoading(false);
                setIpStatusText("");
                informationDispatch(setIpInformation({}));
            }
            if (res.status === 404)  {
                errorsDispatch(setError("error404: IP address or domain name is not found in our database"));
                setLoading(false);
                setIpStatusText("");
                informationDispatch(setIpInformation({}));
            }
            if (res.status === 423)  {
                errorsDispatch(setError("error423: Bogus IP address from the bogon space"));
                setLoading(false);
                setIpStatusText("");
                informationDispatch(setIpInformation({}));
            }
            if (res.status === 429)  {
                errorsDispatch(setError("error429: Limit has reached "));
                setLoading(false);
                setIpStatusText("");
                informationDispatch(setIpInformation({}));
            }
           


            if (!res.ok){
                throw Error("check the url or network settings");
            }
         
           
            errorsDispatch(setError(""));
            return res.json();
           

        }).then((data) => {
            informationDispatch(setIpInformation(data));
            setLoading(false);
        }).catch((e) => {
           console.log(e.message);
           setIpStatusText("");
         })
   

    }, [errorsDispatch, informationDispatch, url ]);
     /*End of get public ip info while loading page */


      /* get specific ip info while submitting a form*/
     /* End of get specific ip info while submitting a form*/

    return (

        <Box p={3}  bgcolor='#F0F9F6'>
            <AccountMenu />

            
          <Box
             
             display="flex"
             flexDirection="column"
             alignItems="center"
             bgcolor='#F6F5F9'
             borderRadius='12px'
             boxShadow='2'
             p={5}
       
                
                >
                <Stack>
                  <UpperText />
                </Stack>
        
                      

                        <Stack>
                            <IpLookup setIpStatusText={setIpStatusText}/>
                        </Stack>


                       <Stack>
                       <Typography variant="subtitle1" component="h2" p={5} color="#969699">
                                        {ipStatusText}
                                        </Typography>
                        
                       </Stack>

                      { 
                      
                      
                                loading ?   <Stack> 
                                <Loading /></Stack> : 


                              <Box>

                                   {errors ? <p>{errors}</p> :
                                     <Box>


                                    <Stack spacing={2} p={2}  display="flex"
                                                flexDirection="column"
                                                alignItems="center">
                                    <Typography variant="h3">{ipInformation.ip}</Typography>
                                    <Divider />
                                    </Stack>

                                        <Stack direction="row" spacing={4} p={2} borderBottom={1} borderColor="#DCDCE2">
                                            <Stack spacing={1} p={3} >
                                            <Typography variant='subtitle2' color="#969699">Country:</Typography>
                                            <Typography variant='body1'>{ipInformation.country_name}</Typography>
                                            </Stack>
                                       
                                            <Stack spacing={1} p={3}>

                                                <Avatar  alt="" src={ipInformation.country_flag} />
                                            </Stack>
                                       </Stack>
                                  
                                    
                                    
                                           <Stack direction="row" spacing={1} p={2} borderBottom={1} borderColor="#DCDCE2">

                                             
                                           <Stack spacing={1} p={2}>
                                               <Typography variant='subtitle2' color="#969699">ISP: </Typography>
                                               <Typography>{ipInformation.isp}</Typography>
                                            </Stack>

                                            <Stack spacing={1} p={2}>
                                               <Typography variant='subtitle2' color="#969699" >City:</Typography>
                                               <Typography>{ipInformation.city}</Typography>
                                            </Stack>
                                    
                                    
                                    
                                           
                                    
                                           </Stack>
                                    
                                        <Stack direction="row" spacing={1} p={2} borderBottom={1} borderColor="#DCDCE2">
                                           
                                           
                                        <Stack spacing={1} p={2}>
                                               <Typography variant='subtitle2' color="#969699">Continent: </Typography>
                                               <Typography>{ipInformation.continent_name}</Typography>
                                               </Stack>
                                           <Stack spacing={1} p={2}>
                                               <Typography variant='subtitle2' color="#969699">State Province: </Typography>
                                               <Typography>{ipInformation.state_prov}</Typography>
                                           </Stack>
                                      

                             
                                       
                                        </Stack>
                                    
                                    
                                          <Stack direction="row" spacing={1} p={2} borderBottom={1} borderColor="#DCDCE2">
                                          
                                          <Stack spacing={1} p={2}>
                                               <Typography variant='subtitle2' color="#969699">Country Capital: </Typography>
                                               <Typography>{ipInformation.country_capital}</Typography>
                                            </Stack>
                                          <Stack spacing={1} p={2}>
                                               <Typography variant='subtitle2' color="#969699">Zipcode: </Typography>
                                               <Typography>{ipInformation.zipcode}</Typography>
                                           </Stack>
                                    
                                       
                                          
                                       </Stack>


                                       <Stack direction="row" spacing={1} p={2} borderBottom={1} borderColor="#DCDCE2">

                                       
                                       <Stack spacing={1} p={2}>
                                               <Typography variant='subtitle2' color="#969699">Calling Code:</Typography>
                                               <Typography>{ipInformation.calling_code}</Typography>
                                          </Stack>
                                     

                                       <Stack spacing={1} p={2}>
                                               <Typography variant='subtitle2' color="#969699">Connection Type: </Typography>
                                               <Typography>{ipInformation.organization}</Typography>
                                            </Stack>
                    

                                       </Stack>

                                       <Stack direction="row" spacing={1} p={2} borderBottom={1} borderColor="#DCDCE2">

                                            <Stack spacing={1} p={2}>
                                               <Typography variant='subtitle2' color="#969699">Languages: </Typography>
                                               <Typography>{ipInformation.languages}</Typography>
                                            </Stack> 
                                      </Stack>

                                     
                                                  
                                                   </Box>
                                      
                                    }
                                          
                            </Box>


                      }
                        
                        
                <Stack>
                  <LowerText />
                </Stack>

          </Box>
          </Box>
       
       
    );
}

export default Home;



